import { useContext } from 'react';
import { ReceiptContext } from 'src/sections/receipt_details/ReceiptContext';

const useReceiptDetails = () => {
  const context = useContext(ReceiptContext);
  if (!context)
    throw new Error('receipt details context must be used inside ReceiptDetailsProvider');
  return context;
};

export default useReceiptDetails;
